import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './tac-car-club'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);